import { render, staticRenderFns } from "./LglComplaintsEdit.vue?vue&type=template&id=4dcceb19&"
import script from "./LglComplaintsEdit.vue?vue&type=script&lang=js&"
export * from "./LglComplaintsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports